import axios from 'axios';
import { localStorageItem } from '../../../../../../../../../utils/LocalStorage';
import { KEY_LOCALSTORAGE } from '../../../../../../../../../auth/core/_consts';
import { OctResponse } from '../../../../../../../../../models/OctResponse';
import { APP_CONFIGURATION_KEYS } from '../../../../../../../../../utils/Constant';

const API_PATH =
	localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.INPATIENT_URL] || process.env.REACT_APP_INPATIENT_API_URL;

export const getThongTinBenhAn = async (
	id: string,
	formName: string
): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(
		`${API_PATH}/medical-record/record/${id}/${formName}`
	);
	return data;
};

export const updateThongTinBenhAn = async (
	id: string,
	formName: string,
	params: any
): Promise<OctResponse<any>> => {
	const { data } = await axios.put<OctResponse<any>>(
		`${API_PATH}/medical-record/record/${id}/${formName}`,
		params
	);
	return data;
};

export const printMedicalRecord = async (params: { id: string, form?: string }) => {
	return await axios.post<Blob>(`${API_PATH}/download/medical-record`, params, {
		responseType: 'blob',
	});
};

export const getMedicalRecordForm = async (medicalRecordCode: string, formName: string) => {
	const { data } = await axios.get(
		`${API_PATH}/term-models/${medicalRecordCode}_${formName}/model-json`
	);
	return data;
};

export const getDsTabBenhAn = async (medicalRecordTypeCode: string) => {
	const { data } = await axios.get(
		`${API_PATH}/medical-record/record/forms`,
		{ params: { medicalRecordTypeCode } }
	);
	return data;
};
